'use strict';

let AccountServiceModule = require('./AccountService');

module.exports = function(param){
    // Adding support to use individual module standalone
    if(typeof param !== "object"){
        param = {};
    }
    // providing option to inject Custom EventBus
    if(param && typeof param._EventBus !== "object"){
        param._EventBus = require('../core/EventBus');
    }
    return new AccountServiceModule(param);
};


// WEBPACK FOOTER //
// ./src/account/index.js